import styles from './AppStoreButtons.module.css'
import { useEffect } from 'react'

function AppStoreButtons({ theme = 'light', position = 'center' }) {
  const appStoreIcon = theme === 'light' ? '/AppleLightAlt3.svg' : '/AppleLightAlt1.svg'
  const googlePlayIcon = theme === 'light' ? '/GoogleLightAlt3.svg' : '/GoogleLightAlt1.svg'

  const positionClass = position === 'left' ? styles.positionLeft : styles.positionCenter

  useEffect(() => {
    const ios = document.querySelectorAll('.af-ios-link')
    const andr = document.querySelectorAll('.af-android-link')

    if (!ios || !andr) {
      return
    }

    let pollId
    let tries = 0

    const attempt = () => {
      tries += 1

      // ①  Wait until Smart-Script is present
      if (!window.AF_SMART_SCRIPT) {
        return // try again in 300 ms
      }

      // ②  Ask Smart-Script for a OneLink
      const result = window.AF_SMART_SCRIPT.generateOneLinkURL({
        oneLinkURL: 'https://clearwatt.onelink.me/YqnR', // template root, not a custom link
        afParameters: {
          mediaSource: {
            keys: ['pid', 'utm_source'],
            defaultValue: 'website_footer',
          },
          campaign: {
            keys: ['c', 'utm_campaign'],
            defaultValue: 'footer_cta',
          },
        },
      })

      // ③  Got a real link?
      const clickURL = result && result.clickURL
      if (!clickURL) return // null ⇒ template ID or domain mis-match

      // ④  Overwrite the buttons
      ios.forEach((a) => (a.href = clickURL))
      andr.forEach((a) => (a.href = clickURL))

      clearInterval(pollId) // stop polling – success
    }

    pollId = setInterval(attempt, 300) // poll every 300 ms
    attempt() // first try immediately

    return () => clearInterval(pollId) // clean-up on unmount
  }, [])

  return (
    <div className={`${styles.appStoreButtonsContainer} ${positionClass}`}>
      <a className="af-ios-link" target="_blank" rel="noopener noreferrer" aria-label="Download on the App Store">
        <img src={appStoreIcon} alt="Download on the App Store" className={styles.appStoreIcon} />
      </a>
      <a className="af-android-link" target="_blank" rel="noopener noreferrer" aria-label="Get it on Google Play">
        <img src={googlePlayIcon} alt="Get it on Google Play" className={styles.googlePlayIcon} />
      </a>
    </div>
  )
}

export default AppStoreButtons
